import { get } from "firebase/database";
import { traerComunidades } from "app/views/gremios/FuncionesGremios";
import { PDFDocument, rgb } from "pdf-lib";
import { getFunctions, httpsCallable } from "firebase/functions";

function getSubJson(obj, key) {
  return obj[key] || null;
}

export const obtenerMetas = async (Identificador, firebase) => {
  const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
  const obtenerMetadatosUsuario = httpsCallable(functions, "getOwnerMetadata");

  await obtenerMetadatosUsuario({
    id: Identificador,
    mode: "user",
  }).then((data) => {
    const usuarioData = data.data[Identificador];
    if (usuarioData) {
      return usuarioData;
    }
  });
};

/**
 * Descarga un contrato en formato PDF con los datos proporcionados.
 *
 * Esta función carga un archivo PDF, rellena los campos del formulario con los datos del contrato,
 * y luego permite descargar el archivo PDF modificado.
 *
 * @async
 * @function descargarPDFContratoDespacho
 * @param {Object} contrato - Objeto que contiene los datos del contrato.
 * @param {string} contrato.plan - Nombre del plan contratado.
 * @param {number} contrato.precioSelected - Precio seleccionado para el contrato.
 * @param {string} contrato.formapago - Forma de pago seleccionada para el contrato.
 * @param {number} contrato.vecinos - Número de vecinos asociados al contrato.
 * @param {string} nombreFichero - Nombre del archivo que se descargará con la extensión `.pdf`.
 *
 * @returns {Promise<void>} No retorna valor, solo dispara el proceso de descarga del archivo PDF.
 *
 * @example
 * const contrato = {
 *   plan: 'Basico',
 *   precioSelected: 100,
 *   formapago: 'mensual',
 *   vecinos: 20
 * };
 * descargarPDFContrato(contrato, 'Contrato_Las_Palmeras');
 */
export const descargarPDFContratoDespacho = async (contrato, nombreFichero) => {
  console.log("Descargando contrato con los datos:", contrato);
  // 1. Cargar el archivo PDF como array buffer

  const url = "/assets/files/contratodespacho.pdf"; // Ruta al PDF
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());

  // 2. Cargar el PDF con pdf-lib
  const pdfDoc = await PDFDocument.load(existingPdfBytes);

  // Obtener el formulario
  const form = pdfDoc.getForm();

  // Obtener todos los campos de formulario
  const fields = form.getFields();

  fields.forEach((field) => {
    console.log("Campo:", field.getName());
  });

  // Obtenemos y rellenamos cada campo del PDF con los datos del objeto
  const nameFieldNombreAdmin = form.getTextField("NombreAdmin");
  nameFieldNombreAdmin.setText(contrato.NombreAdmin.toString());

  const nameFieldDni = form.getTextField("Dni");
  nameFieldDni.setText(contrato.Dni.toString());

  const nameFieldNombreDespacho = form.getTextField("NombreDespacho");
  nameFieldNombreDespacho.setText(contrato.NombreDespacho.toString());

  const nameFieldCiudad = form.getTextField("Ciudad");
  nameFieldCiudad.setText(contrato.Ciudad.toString());

  const nameFieldProvincia = form.getTextField("Provincia");
  nameFieldProvincia.setText(contrato.Provincia.toString());

  const nameFieldCodigoPostal = form.getTextField("CodigoPostal");
  nameFieldCodigoPostal.setText(contrato.CodigoPostal.toString());

  const nameFieldCalle = form.getTextField("Calle");
  nameFieldCalle.setText(contrato.Calle.toString());

  const nameFieldMailContacto = form.getTextField("MailContacto");
  nameFieldMailContacto.setText(contrato.MailContacto.toString());

  const nameFieldTelefono = form.getTextField("Telefono");
  nameFieldTelefono.setText(contrato.Telefono.toString());

  const nameFieldIban = form.getTextField("Iban");
  nameFieldIban.setText(contrato.Iban.toString());

  const nameFieldDia = form.getTextField("Dia");
  nameFieldDia.setText(contrato.Dia.toString());

  const nameFieldMes = form.getTextField("Mes");
  nameFieldMes.setText(contrato.Mes.toString());

  const nameFieldAnio = form.getTextField("Anio");
  nameFieldAnio.setText(contrato.Anio.toString());
  form.flatten();
  const pages = pdfDoc.getPages();
  const firstPage = pages[3];

  // 4. Guardar el PDF modificado
  const pdfBytes = await pdfDoc.save();

  // Descargar el PDF
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = nombreFichero + ".pdf";
  link.click();
};

export const obtenerDatosContrato = (user, Identificador = "") => {
  const currentDate = new Date();
  const dia = currentDate.getDate();
  const mes = currentDate.toLocaleString("es-ES", { month: "long" });
  const anio = currentDate.getFullYear();
  const fechaContrato = currentDate.toLocaleString("es-ES", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  });
  const nombreContrato = `${Identificador ?? "SinNombre"}-${fechaContrato.replaceAll("/", "-")}`;
  console.log("FINALRU FLASH !!! El nombre del contrato es:", nombreContrato);
  console.log("El user es:", user);

  const contrato = {
    NombreAdmin: user.datosUsuarioBD
      ? `${user.datosUsuarioBD.Nombre ?? ""} ${user.datosUsuarioBD.Apellido ?? ""} ${
          user.datosUsuarioBD.Apellido2 ?? ""
        }`
      : "",
    Dni: user.datosUsuarioBD?.DNI ?? "",
    ColegiadoDespacho: user.datosUsuarioBD?.ColegiadoDespacho ?? "",
    NombreDespacho: user.despacho?.Nombre ?? "",
    Ciudad: user.despacho?.Poblacion ?? "",
    Provincia: user.despacho?.Provincia ?? "",
    CodigoPostal: user.despacho?.Cp ?? "",
    Calle: user.despacho?.Direccion ?? "",
    MailContacto: user.despacho?.Correo ?? "",
    Telefono: user.despacho?.Telefono1 ?? "",
    Iban: user.despacho?.Iban ?? "",
    Dia: dia,
    Mes: mes,
    Anio: anio,
  };

  console.log("El contrato es:", contrato);
  return contrato;
};

export const loadAdminUsers = async (firebase, fichar = false, metadatos = false) => {
  try {
    const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
    const obtenerMetadatosUsuario = httpsCallable(functions, "getOwnerMetadata");
    let snapshot = await get(firebase.getReferencia("Usuarios", null));
    let datos = [];
    const comunidadeslista = await traerComunidades(firebase);

    const snapFichajes = await get(firebase.getReferencia("Fichar"));

    const snapFlujosCorreo = await get(firebase.getReferencia("Flujocorreos"));
    const flujoCorreos = snapFlujosCorreo.val();

    const fichajes = snapFichajes.val();

    snapshot.forEach((childSnapshot) => {
      const childKey = childSnapshot.key;

      let childData = childSnapshot.val();
      childData.idInterno = childKey;

      if (fichar) {
        childData.fichajes = fichajes && getSubJson(fichajes, childKey);
      }
      // childData.metas = obtenerMetas(childKey, firebase, functions);
      if (
        childData &&
        childData["PerfilEmpleadoOficina"] &&
        childData["PerfilEmpleadoOficina"] !== ""
      ) {
        // Si no tiene la propiedad flujocorreos todo por defecto a que sí
        childData.Flujocorreos =
          flujoCorreos && flujoCorreos[childKey]
            ? flujoCorreos[childKey]
            : {
                AdminCon: true,
                Cambios: true,
                Consultas: true,
                Incidencias: true,
                Seguros: true,
                Siniestros: true,
                Todo: true,
              };

        childData.Todo = childData.Flujocorreos && childData.Flujocorreos.Todo;
        childData.Cambios = childData.Flujocorreos && childData.Flujocorreos.Cambios;
        childData.Consultas = childData.Flujocorreos && childData.Flujocorreos.Consultas;
        childData.Incidencias = childData.Flujocorreos && childData.Flujocorreos.Incidencias;
        childData.Siniestros = childData.Flujocorreos && childData.Flujocorreos.Siniestros;

        const listaPreparada = [];
        for (let comunidadId in childData.Comunidades) {
          if (comunidadeslista.some((nombre) => nombre.value === comunidadId)) {
            // Busca el nombre de la comunidad en comunidadeslista y lo agrega a listaPreparada
            const nombreComunidad = comunidadeslista.find(
              (comunidad) => comunidad.value === comunidadId
            )?.label;
            if (nombreComunidad) {
              listaPreparada.push(nombreComunidad);
            }
          }
          if (comunidadId === "desk") {
            listaPreparada.push("Todas las comunidades");
          }
        }
        childData.Comunidadeslista = listaPreparada;
        datos.push(childData);
      }
    });

    datos = datos.map((usuario) => {
      const Flujocorreos = snapshot.val()[usuario.Flujocorreos];
      return { ...usuario, ...Flujocorreos };
    });
    if (metadatos) {
      for (const datetes of datos) {
        await obtenerMetadatosUsuario({
          id: datetes.idInterno,
          mode: "user",
        }).then((data) => {
          const usuarioData = data.data[datetes.idInterno];
          if (usuarioData.emailVerified) {
            datetes.AltaC365 = true;
          }
        });
      }
    }
    return datos;
  } catch (error) {
    console.error("Error al cargar usuarios administradores", error);
    throw error; // Puedes lanzar nuevamente el error para que se maneje en el nivel superior si es necesario
  }
};

export const getCategoriasEmpleado = (diccionario) => {
  return [
    { label: diccionario.Administrador, value: "Administrador" },
    { label: diccionario.Oficial, value: "Oficial" },
    { label: diccionario.Auxiliar, value: "Auxiliar" },
  ];
};

export const transformData = (data) => {
  return data.reduce((acc, item) => {
    acc[item.value] = {
      Roles: item.Roles.length > 0 ? item.Roles : [""],
    };
    return acc;
  }, {});
};

export const transformDataDesk = (rolesSeleccionados) => {
  return {
    desk: {
      Roles: rolesSeleccionados.length > 0 ? rolesSeleccionados : [""],
    },
  };
};
